import { Component, OnInit, isDevMode } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  constructor(private router: Router, private cookieService: CookieService) {}

  ngOnInit(): void {
    if (isDevMode()) {
      console.log('👋 Development!');
    } else {
      console.log('💪 Production!');
    }
    // Keep an existing session alive across reloads and new tabs.
    // Only force the login screen when there is no logged-in user.
    const loggedInUser = window.localStorage.getItem('loggedInUser');
    if (!loggedInUser) {
      this.cookieService.delete('LOGIN_TOKEN');
      window.localStorage.removeItem('loggedInUserName');
      window.localStorage.removeItem('clientSessionId');
      this.router.navigate(['login']);
    }
  }
  title = 'Som-Water';
}
